import {
  SOL_BOOT_SPLASH_DIAMOND_SRC,
  SOL_BOOT_SPLASH_LOCKUP_SRC,
  SOL_BOOT_SPLASH_TAGLINE_SRC,
} from './solBootSplashAssets';

type SolBootSplashMarkProps = {
  id?: string;
  testId?: string;
};

export function SolBootSplashMark({ id, testId }: SolBootSplashMarkProps) {
  return (
    <div aria-hidden="true" className="sol-boot-splash" data-testid={testId} id={id}>
      <div className="sol-boot-splash__inner">
        <img
          alt=""
          className="sol-boot-splash__diamond"
          src={SOL_BOOT_SPLASH_DIAMOND_SRC}
        />
        <div className="sol-boot-splash__spacer--1" />
        <img
          alt=""
          className="sol-boot-splash__lockup"
          src={SOL_BOOT_SPLASH_LOCKUP_SRC}
        />
        <div className="sol-boot-splash__spacer--3" />
        <img
          alt=""
          className="sol-boot-splash__tagline"
          src={SOL_BOOT_SPLASH_TAGLINE_SRC}
        />
      </div>
    </div>
  );
}
